(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["easyusa-guide-article"]) return;
  try {
    
  if (!customElements.get('easyusa-guide-article')) {
    customElements.define('easyusa-guide-article', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        const content = this.querySelector('.eu-guide__content');
        const toc = this.querySelector('.eu-guide__toc');
        if (!content || !toc) return;
        this.ready = true;
        const headings = [...content.querySelectorAll('h2')];
        const list = toc.querySelector('ol');
        const links = new Map();
        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = `${this.id}-section-${index + 1}`;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.dataset.toc || heading.textContent;
          item.append(link);
          list.append(item);
          links.set(heading, link);
        });
        toc.hidden = headings.length === 0;
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            const visible = entries.filter(entry => entry.isIntersecting);
            if (!visible.length) return;
            links.forEach(link => link.removeAttribute('aria-current'));
            links.get(visible[0].target).setAttribute('aria-current', 'location');
          }, { rootMargin: '-15% 0px -60% 0px' });
          headings.forEach(heading => this.observer.observe(heading));
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.querySelector('.eu-guide__toc ol')?.replaceChildren();
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["easyusa-hero-bento"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('easyusa-bento-scroll')) customElements.define('easyusa-bento-scroll',class extends HTMLElement{
 connectedCallback(){
  this.abort=new AbortController();const signal=this.abort.signal;
  this.row=this.querySelector('.easyusa-bento__tile-row');
  if(!this.row)return;
  this.update=this.update.bind(this);
  this.row.addEventListener('scroll',this.update,{signal,passive:true});
  this.update();
  this.bindDrag(signal);
 }
 bindDrag(signal){
  const row=this.row;
  let isDown=false,moved=false,startX=0,startScroll=0;
  // Pointer Events, gated to pointerType==='mouse' only — real touch
  // devices already have working native swipe scrolling (that's what
  // this row's own overflow-x:auto + -webkit-overflow-scrolling:touch
  // is for) and mobile browsers synthesize mouse events from taps for
  // compatibility, so generic mousedown/mousemove/mouseup listeners
  // here previously hijacked real taps on phones — the row would pan a
  // few px on tap, "moved" would read true, and the subsequent click
  // (the actual navigation) got swallowed, requiring a long-press to
  // open the link instead of a normal tap. This only exists to give
  // desktop (mouse, no touchscreen) a way to scroll the row at all.
  row.addEventListener('pointerdown',event=>{
   if(event.pointerType!=='mouse')return;
   isDown=true;moved=false;startX=event.clientX;startScroll=row.scrollLeft;
   row.classList.add('is-dragging');
  },{signal});
  row.addEventListener('dragstart',event=>event.preventDefault(),{signal});
  window.addEventListener('pointermove',event=>{
   if(!isDown||event.pointerType!=='mouse')return;
   const dx=event.clientX-startX;
   if(Math.abs(dx)>4)moved=true;
   row.scrollLeft=startScroll-dx;
  },{signal});
  window.addEventListener('pointerup',event=>{
   if(!isDown||event.pointerType!=='mouse')return;
   isDown=false;
   // Tiles are links — if this was a real drag, keep pointer-events off
   // them through the click that immediately follows pointerup so the
   // drag doesn't also trigger a card navigation, then release it.
   if(moved)setTimeout(()=>row.classList.remove('is-dragging'),0);
   else row.classList.remove('is-dragging');
  },{signal});
 }
 update(){
  const atEnd=this.row.scrollLeft+this.row.clientWidth>=this.row.scrollWidth-4;
  this.classList.toggle('is-at-end',atEnd);
 }
 disconnectedCallback(){this.abort?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["easyusa-inventory-tracker"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = async (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const app = root.querySelector('[data-inventory-app]');
      if (!app) return;

      const config = JSON.parse(root.querySelector('[data-inventory-config]').textContent);
      const passwordGate = root.querySelector('[data-inventory-password-gate]');
      const passwordForm = root.querySelector('[data-inventory-password-form]');
      const passwordError = root.querySelector('[data-inventory-password-error]');
      const unlock = () => {
        passwordGate.hidden = true;
        app.hidden = false;
      };

      if (!config.accessPassword || sessionStorage.getItem(config.passwordStorageKey) === 'granted') {
        unlock();
      } else {
        passwordForm.addEventListener('submit', (event) => {
          event.preventDefault();
          if (passwordForm.elements.password.value === config.accessPassword) {
            sessionStorage.setItem(config.passwordStorageKey, 'granted');
            passwordError.hidden = true;
            unlock();
            app.querySelector('[data-inventory-search]').focus();
          } else {
            passwordError.hidden = false;
            passwordForm.elements.password.select();
          }
        });
      }

      const source = JSON.parse(root.querySelector('[data-easyusa-inventory-source]').textContent);
      const indexView = root.querySelector('[data-inventory-index]');
      const detailView = root.querySelector('[data-inventory-detail]');
      const mainRows = root.querySelector('[data-inventory-rows]');
      const detailRows = root.querySelector('[data-detail-rows]');
      const search = root.querySelector('[data-inventory-search]');
      const filter = root.querySelector('[data-inventory-filter]');
      const count = root.querySelector('[data-inventory-count]');
      const empty = root.querySelector('[data-inventory-empty]');
      const status = root.querySelector('[data-inventory-status]');
      const form = root.querySelector('[data-inventory-form]');
      const newRecordForm = root.querySelector('[data-new-record-form]');
      let products = [];
      let productMap = new Map();
      let activeKey = null;
      let serverVersion = 0;
      let requestInFlight = false;
      let indexSort = { key: 'item', direction: 'asc' };
      let detailSort = { key: 'date', direction: 'asc' };

      const visibleProducts = () => products;
      const allTransactions = (product) => product.transactions.map((transaction, index) => {
        if (Array.isArray(transaction)) {
          return {
            date: transaction[0],
            quantity: transaction[1],
            direction: transaction[2],
            origin: 'source',
            id: `source-${index}`,
          };
        }
        return transaction;
      });

      const apiRequest = async (action, payload = {}, includeSeed = false) => {
        const response = await fetch(config.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action,
            password: config.accessPassword,
            ...(includeSeed ? { seed: source.products } : {}),
            ...payload,
          }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok || !data.ok) throw new Error(data.error || config.labels.serverError);
        return data;
      };

      const replaceSharedState = (data) => {
        products = Array.isArray(data.products) ? data.products : [];
        products.sort((left, right) => left.item.localeCompare(right.item, undefined, { numeric: true, sensitivity: 'base' }));
        productMap = new Map(products.map((product) => [product.key, product]));
        serverVersion = Number(data.version) || serverVersion;
      };

      const balanceFor = (product) => allTransactions(product).reduce((balance, transaction) => {
        return balance + (transaction.direction === 'Out' ? -transaction.quantity : transaction.quantity);
      }, 0);

      const sortableDate = (value) => /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : '';
      const lastActivityFor = (product) => allTransactions(product).reduce((latest, transaction) => {
        return sortableDate(transaction.date) > sortableDate(latest) ? transaction.date : latest;
      }, '');
      const displayDate = (value) => {
        if (!sortableDate(value)) return value || config.labels.blankValue;
        const [year, month, day] = value.split('-').map(Number);
        return new Intl.DateTimeFormat(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
          .format(new Date(year, month - 1, day));
      };
      const displayValue = (value) => value || config.labels.blankValue;
      const formatNumber = (value) => new Intl.NumberFormat().format(value);
      const compareValues = (left, right) => {
        if (typeof left === 'number' && typeof right === 'number') return left - right;
        return String(left || '').localeCompare(String(right || ''), undefined, { numeric: true, sensitivity: 'base' });
      };
      const sortRows = (rows, sort, tieBreaker) => rows.sort((left, right) => {
        const comparison = compareValues(left[sort.key], right[sort.key]);
        if (comparison !== 0) return sort.direction === 'asc' ? comparison : -comparison;
        return tieBreaker(left, right);
      });
      const nextSort = (current, key) => {
        if (current.key === key) {
          return { key, direction: current.direction === 'asc' ? 'desc' : 'asc' };
        }
        const descendingFirst = ['balance', 'quantity', 'lastActivity'].includes(key);
        return { key, direction: descendingFirst ? 'desc' : 'asc' };
      };
      const updateSortHeaders = (view, sort) => {
        root.querySelectorAll(`[data-inventory-sort="${view}"]`).forEach((button) => {
          const active = button.dataset.sortKey === sort.key;
          const header = button.closest('th');
          const indicator = button.querySelector('[data-sort-indicator]');
          if (active) {
            header.setAttribute('aria-sort', sort.direction === 'asc' ? 'ascending' : 'descending');
            indicator.textContent = sort.direction === 'asc' ? '▲' : '▼';
          } else {
            header.removeAttribute('aria-sort');
            indicator.textContent = '↕';
          }
        });
      };

      const createCell = (text, className = '') => {
        const cell = document.createElement('td');
        cell.textContent = text;
        if (className) cell.className = className;
        return cell;
      };

      const openRecord = (key, pushState = true) => {
        const product = productMap.get(key);
        if (!product) return;
        activeKey = key;
        indexView.hidden = true;
        detailView.hidden = false;
        root.querySelector('[data-detail-title]').textContent = `${product.item} · ${displayValue(product.color)}`;
        root.querySelector('[data-detail-meta]').textContent = `${config.labels.cartons} · ${displayValue(product.size)}`;
        renderDetail();
        if (pushState) {
          const url = new URL(window.location.href);
          url.searchParams.set('record', key);
          history.pushState({ inventoryRecord: key }, '', url);
        }
        detailView.querySelector('h2').focus({ preventScroll: true });
        window.scrollTo({ top: root.offsetTop, behavior: 'smooth' });
      };

      const closeRecord = (pushState = true) => {
        activeKey = null;
        detailView.hidden = true;
        indexView.hidden = false;
        if (pushState) {
          const url = new URL(window.location.href);
          url.searchParams.delete('record');
          history.pushState({}, '', url);
        }
        renderIndex();
        search.focus({ preventScroll: true });
        window.scrollTo({ top: root.offsetTop, behavior: 'smooth' });
      };

      const renderStats = () => {
        const balances = visibleProducts().map(balanceFor);
        root.querySelector('[data-stat-cartons]').textContent = formatNumber(balances.reduce((total, balance) => total + balance, 0));
        root.querySelector('[data-stat-records]').textContent = formatNumber(balances.length);
        root.querySelector('[data-stat-in-stock]').textContent = formatNumber(balances.filter((balance) => balance > 0).length);
        root.querySelector('[data-stat-out-of-stock]').textContent = formatNumber(balances.filter((balance) => balance === 0).length);
      };

      const renderIndex = () => {
        const query = search.value.trim().toLocaleLowerCase();
        const stockFilter = filter.value;
        const visible = visibleProducts().filter((product) => {
          const balance = balanceFor(product);
          const matchesQuery = !query || [product.item, product.color, product.size]
            .join(' ')
            .toLocaleLowerCase()
            .includes(query);
          const matchesStock = stockFilter === 'all'
            || (stockFilter === 'in-stock' && balance > 0)
            || (stockFilter === 'out-of-stock' && balance === 0);
          return matchesQuery && matchesStock;
        }).map((product) => ({
          product,
          item: product.item,
          color: product.color,
          size: product.size,
          balance: balanceFor(product),
          lastActivity: lastActivityFor(product),
        }));
        sortRows(visible, indexSort, (left, right) => compareValues(left.item, right.item));

        mainRows.replaceChildren();
        const fragment = document.createDocumentFragment();
        for (const entry of visible) {
          const { product, balance } = entry;
          const row = document.createElement('tr');
          const itemCell = document.createElement('td');
          const itemButton = document.createElement('button');
          itemButton.type = 'button';
          itemButton.className = 'easyusa-inventory__item-button';
          itemButton.dataset.inventoryOpen = product.key;
          itemButton.textContent = product.item;
          itemCell.append(itemButton);
          row.append(
            itemCell,
            createCell(displayValue(product.color)),
            createCell(displayValue(product.size)),
            createCell(formatNumber(balance), `easyusa-inventory__numeric${balance === 0 ? ' easyusa-inventory__balance-zero' : ''}`),
            createCell(displayDate(lastActivityFor(product))),
          );
          const actionCell = document.createElement('td');
          const openButton = document.createElement('button');
          openButton.type = 'button';
          openButton.className = 'easyusa-inventory__row-open';
          openButton.dataset.inventoryOpen = product.key;
          openButton.setAttribute('aria-label', `${product.item}: ${displayValue(product.color)}`);
          openButton.textContent = '›';
          const deleteButton = document.createElement('button');
          deleteButton.type = 'button';
          deleteButton.className = 'easyusa-inventory__delete';
          deleteButton.dataset.deleteProduct = product.key;
          deleteButton.textContent = config.labels.deleteRecord;
          actionCell.className = 'easyusa-inventory__row-actions';
          actionCell.append(openButton, deleteButton);
          row.append(actionCell);
          fragment.append(row);
        }
        mainRows.append(fragment);
        empty.hidden = visible.length !== 0;
        count.textContent = `${formatNumber(visible.length)} ${config.labels.results}`;
        updateSortHeaders('index', indexSort);
        renderStats();
      };

      const renderDetail = () => {
        const product = productMap.get(activeKey);
        if (!product) return;
        const transactions = allTransactions(product);
        let runningBalance = 0;
        const transactionRows = transactions.map((transaction, sourceIndex) => {
          runningBalance += transaction.direction === 'Out' ? -transaction.quantity : transaction.quantity;
          return { ...transaction, balance: runningBalance, sourceIndex };
        });
        const currentBalance = runningBalance;
        sortRows(transactionRows, detailSort, (left, right) => left.sourceIndex - right.sourceIndex);
        detailRows.replaceChildren();
        const fragment = document.createDocumentFragment();

        for (const transaction of transactionRows) {
          const row = document.createElement('tr');
          row.append(
            createCell(displayDate(transaction.date)),
            createCell(formatNumber(transaction.quantity), 'easyusa-inventory__numeric'),
          );
          const directionCell = document.createElement('td');
          const direction = document.createElement('span');
          const directionLabel = transaction.direction === 'Initial'
            ? config.labels.initial
            : config.labels[transaction.direction.toLocaleLowerCase()];
          direction.className = `easyusa-inventory__direction easyusa-inventory__direction--${transaction.direction.toLocaleLowerCase()}`;
          direction.textContent = directionLabel;
          directionCell.append(direction);
          row.append(directionCell, createCell(formatNumber(transaction.balance), 'easyusa-inventory__numeric'));
          const originCell = document.createElement('td');
          const origin = document.createElement('span');
          origin.className = 'easyusa-inventory__origin';
          origin.textContent = config.labels[transaction.origin];
          originCell.append(origin);
          row.append(originCell);
          const actionCell = document.createElement('td');
          if (transaction.origin === 'shared') {
            const deleteButton = document.createElement('button');
            deleteButton.type = 'button';
            deleteButton.className = 'easyusa-inventory__delete';
            deleteButton.dataset.deleteTransaction = transaction.id;
            deleteButton.textContent = config.labels.deleteTransaction;
            actionCell.append(deleteButton);
          }
          row.append(actionCell);
          fragment.append(row);
        }

        detailRows.append(fragment);
        root.querySelector('[data-detail-balance]').textContent = formatNumber(currentBalance);
        updateSortHeaders('detail', detailSort);
        renderStats();
      };

      const csvCell = (value) => {
        const text = String(value ?? '');
        return /[",\n]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text;
      };

      const exportCsv = () => {
        const rows = [['Date', 'Item#', 'Color', 'Size', 'Number of Ctns', 'In/Out', 'Match Key', 'Origin']];
        for (const product of visibleProducts()) {
          for (const transaction of allTransactions(product)) {
            rows.push([
              transaction.date,
              product.item,
              product.color,
              product.size,
              transaction.quantity,
              transaction.direction,
              product.key,
              transaction.origin === 'shared' ? config.labels.shared : config.labels.source,
            ]);
          }
        }
        const body = rows.map((row) => row.map(csvCell).join(',')).join('\r\n');
        const blob = new Blob([body], { type: 'text/csv;charset=utf-8' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `location-2-inventory-${new Date().toISOString().slice(0, 10)}.csv`;
        link.click();
        URL.revokeObjectURL(link.href);
      };

      const renderCurrentView = () => {
        if (activeKey && productMap.has(activeKey)) renderDetail();
        else {
          activeKey = null;
          detailView.hidden = true;
          indexView.hidden = false;
          renderIndex();
        }
      };

      const runSharedAction = async (action, payload, successMessage) => {
        if (requestInFlight) return false;
        requestInFlight = true;
        status.textContent = config.labels.syncing;
        try {
          const data = await apiRequest(action, payload);
          replaceSharedState(data);
          renderCurrentView();
          status.textContent = successMessage;
          return true;
        } catch (error) {
          status.textContent = `${config.labels.serverError} ${error.message}`;
          return false;
        } finally {
          requestInFlight = false;
        }
      };

      root.addEventListener('click', async (event) => {
        const sortButton = event.target.closest('[data-inventory-sort]');
        if (sortButton) {
          if (sortButton.dataset.inventorySort === 'index') {
            indexSort = nextSort(indexSort, sortButton.dataset.sortKey);
            renderIndex();
          } else {
            detailSort = nextSort(detailSort, sortButton.dataset.sortKey);
            renderDetail();
          }
          return;
        }

        const openButton = event.target.closest('[data-inventory-open]');
        if (openButton) openRecord(openButton.dataset.inventoryOpen);

        if (event.target.closest('[data-inventory-back]')) closeRecord();
        if (event.target.closest('[data-inventory-export]')) exportCsv();

        const deleteProductButton = event.target.closest('[data-delete-product]');
        if (deleteProductButton) {
          const key = deleteProductButton.dataset.deleteProduct;
          if (!window.confirm(config.labels.confirmDeleteRecord)) return;
          await runSharedAction('deleteRecord', { key }, config.labels.recordDeleted);
        }

        const deleteButton = event.target.closest('[data-delete-transaction]');
        if (deleteButton && activeKey) {
          await runSharedAction('deleteTransaction', {
            key: activeKey,
            transactionId: deleteButton.dataset.deleteTransaction,
          }, config.labels.transactionRemoved);
        }
      });

      search.addEventListener('input', renderIndex);
      filter.addEventListener('change', renderIndex);
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const product = productMap.get(activeKey);
        if (!product) return;
        const data = new FormData(form);
        const quantity = Number(data.get('quantity'));
        const direction = data.get('direction');
        if (!Number.isInteger(quantity) || quantity < 1 || !['In', 'Out'].includes(direction)) return;
        if (direction === 'Out' && quantity > balanceFor(product)) {
          status.textContent = config.labels.invalidWithdrawal;
          return;
        }
        const saved = await runSharedAction('addTransaction', {
          key: activeKey,
          date: String(data.get('date')),
          quantity,
          direction,
        }, config.labels.transactionAdded);
        if (!saved) return;
        form.reset();
        form.elements.date.value = new Date().toISOString().slice(0, 10);
      });

      newRecordForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        const data = new FormData(newRecordForm);
        const item = String(data.get('item')).trim();
        const color = String(data.get('color')).trim();
        const size = String(data.get('size')).trim();
        const quantity = Number(data.get('quantity'));
        const date = String(data.get('date'));
        const key = `${item}|${color}`;
        if (!item || !color || !Number.isInteger(quantity) || quantity < 0 || !date) return;
        if (productMap.has(key)) {
          status.textContent = config.labels.recordExists;
          return;
        }
        const saved = await runSharedAction('addRecord', {
          item,
          color,
          size,
          date,
          quantity,
        }, config.labels.recordAdded);
        if (!saved) return;
        newRecordForm.reset();
        newRecordForm.elements.date.value = new Date().toISOString().slice(0, 10);
      });

      window.addEventListener('popstate', () => {
        const key = new URL(window.location.href).searchParams.get('record');
        if (key && productMap.has(key)) openRecord(key, false);
        else closeRecord(false);
      });

      form.elements.date.value = new Date().toISOString().slice(0, 10);
      newRecordForm.elements.date.value = new Date().toISOString().slice(0, 10);
      status.textContent = config.labels.syncing;
      try {
        const initialState = await apiRequest('load', {}, true);
        replaceSharedState(initialState);
        renderIndex();
        status.textContent = '';
        const initialKey = new URL(window.location.href).searchParams.get('record');
        if (initialKey && productMap.has(initialKey)) openRecord(initialKey, false);
      } catch (error) {
        status.textContent = `${config.labels.serverError} ${error.message}`;
      }

      const refreshSharedState = async () => {
        if (requestInFlight || document.hidden) return;
        requestInFlight = true;
        try {
          const data = await apiRequest('load');
          if (Number(data.version) !== serverVersion) {
            replaceSharedState(data);
            renderCurrentView();
          }
        } catch (error) {
          status.textContent = `${config.labels.serverError} ${error.message}`;
        } finally {
          requestInFlight = false;
        }
      };
      window.setInterval(refreshSharedState, 15000);
      window.addEventListener('focus', refreshSharedState);
    };

    const start = () => document.querySelectorAll('[data-inventory-tracker]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["easyusa-launch-article"]) return;
  try {
    
  if (!customElements.get('easyusa-launch-article')) {
    customElements.define('easyusa-launch-article', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        const content = this.querySelector('.eu-launch__content');
        const toc = this.querySelector('.eu-launch__toc');
        if (!content || !toc) return;
        this.ready = true;
        const headings = [...content.querySelectorAll('h2')];
        const list = toc.querySelector('ol');
        const links = new Map();
        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = `${this.id}-chapter-${index + 1}`;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent;
          item.append(link);
          list.append(item);
          links.set(heading, link);
        });
        toc.hidden = headings.length === 0;
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            const visible = entries.filter(entry => entry.isIntersecting);
            if (!visible.length) return;
            links.forEach(link => link.removeAttribute('aria-current'));
            links.get(visible[0].target).setAttribute('aria-current', 'location');
          }, { rootMargin: '-15% 0px -60% 0px' });
          headings.forEach(heading => this.observer.observe(heading));
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.querySelector('.eu-launch__toc ol')?.replaceChildren();
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
